export default "__VITE_ASSET__DD3F5cNL__"